import React, {useMemo} from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import {TITLE_TEXT} from '../../../shared/style/typography';
import {CHARCOAL} from '../../../shared/style/colors';
import {ComponentContainer} from './shared/styles';
import NavAnchor, {NAV_ANCHOR_OFFSET} from '../../tool-profile/components/shared/nav-anchor';
import withErrorBoundary from '../../../shared/enhancers/error-boundary';

const KeywordContainer = glamorous.div({
  marginBottom: 40
});

const Title = glamorous.h2({
  ...TITLE_TEXT,
  fontSize: 18,
  color: CHARCOAL,
  margin: 0
});

const Keyword = glamorous.div({
  ...TITLE_TEXT,
  fontSize: 14,
  color: CHARCOAL,
  marginTop: 8,
  marginRight: 24
});

const ItemContainer = glamorous.div({
  display: 'flex',
  flexWrap: 'wrap'
});

const Keywords = ({tool}) => {
  const {keywords} = tool;
  const items = useMemo(() => {
    return keywords.map((item, index) => <Keyword key={index}>{item}</Keyword>);
  }, [keywords]);

  return (
    <ComponentContainer>
      <NavAnchor id="keywords" offset={NAV_ANCHOR_OFFSET} />
      <KeywordContainer>
        <Title>Keywords</Title>
        <ItemContainer>{items}</ItemContainer>
      </KeywordContainer>
    </ComponentContainer>
  );
};

Keywords.propTypes = {
  tool: PropTypes.shape({
    keywords: PropTypes.array
  })
};

export default withErrorBoundary(true)(Keywords);
